export default async function sendFormDataJson(e, method) {
  let object = {};
  new FormData(e.target).forEach((value, key) => {
    // Reflect.has in favor of: object.hasOwnProperty(key)
    if (!Reflect.has(object, key)) {
      object[key] = value;
      return;
    }
    if (!Array.isArray(object[key])) {
      object[key] = [object[key]];
    }
    object[key].push(value);
  });
  let resp = await fetch(e.target.action, {
    method: method || "post",
    body: JSON.stringify(object),
    headers: {
      "Content-Type": "application/json",
    },
  });
  return resp;
}
